import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Loader } from './modules/App/components/Loader';

/**
 * Route wrapper for pages that require an authenticated user (the no-username dashboard and account
 * pages). Auth hydrates asynchronously via onAuthStateChanged, so we must wait for `authHydrated`
 * before deciding: while it is still resolving we render a loader (NOT the page, and NOT a redirect),
 * and only once resolved do we redirect signed-out users to /login. This avoids both flashing a
 * private page to a signed-out visitor and bouncing a logged-in user who simply refreshed.
 */
// eslint-disable-next-line react/prop-types
const RequireAuthRoute = ({ component: Component, ...rest }) => {
  const authenticated = useSelector((state) => state.user.authenticated);
  const authHydrated = useSelector((state) => state.user.authHydrated);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!authHydrated) {
          return <Loader />;
        }
        if (!authenticated) {
          return <Redirect to="/login" />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default RequireAuthRoute;
